import React, { useEffect, useState } from "react";
import api from "../../Utils/api";
import { accessMap, stressProfileMap } from "../../Utils/const";
import Spinner from "../Spinner";
import ExportDropdown from "../Calendar/ExportDropdown";

function transformUsersDetailed(users) {
  return users.map((user) => ({
    preferred: user.preferredName || `${user.firstName} ${user.lastName}`,
    first: user.firstName || "",
    last: user.lastName || "",
    id: user.id || user._id || "",
    dob: user.birthday || "",
    gender: user.gender || "",
    pronouns: user.pronouns || "",
    location: user.locations?.primaryLocation?.name?.trim() || "Unknown",
    payroll: user.payRollId || user.payrollId || "",
    stress: user.stressProfile || "",
    hired: user.hiredOn
      ? new Date(user.hiredOn).toLocaleDateString("en-GB")
      : "",
    archived: user.flag === "1" ? "Yes" : "",
    tenure: "", // You can calculate tenure if you have data
    status: user.allowed ? "Employed" : "Inactive",
    access: user.deputyAccessLevel || "",
    mobile: user.phone || "",
    email: user.email || "",
    address: user.address || "",
    emergencyName: user.emergencyContactName || "",
    emergencyPhone: user.emergencyContactNumber || "",
    custom: "", // placeholder for any custom info
  }));
}

export default function TeamMemberTable() {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getUsers = async () => {
    setIsLoading(true);
    const res = await api.get("/user");
    setIsLoading(false);
    if (res.data.success) {
      setUsers(res.data.users.filter((u) => !u.archive));
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const teamMembers = transformUsersDetailed(users);

  return (
    <div className="px-6 w-full bg-white">
      {isLoading && <Spinner />}
      <h2 className="text-lg font-semibold mb-4">Team Member Details</h2>
      <ExportDropdown data={teamMembers} />
      <div className="w-full overflow-x-auto  mt-2 max-h-[80vh] overflow-y-auto">
        <table className="min-w-max border border-gray-200  text-sm">
          <thead className="sticky top-0 -mt-1">
            <tr className="bg-gray-50  text-gray-700">
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Preferred name
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                First name
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Last name
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Employee ID
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Date of birth
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Gender
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Pronouns
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Primary location
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Payroll IDs
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Stress profile
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Hired
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Archived
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Tenure (Days)
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Status
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Access level
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Mobile
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Email
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Address
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Emergency contact name
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Emergency contact phone number
              </th>
              <th className="px-2 py-1 border-b whitespace-nowrap text-left">
                Custom fields
              </th>
            </tr>
          </thead>
          <tbody>
            {teamMembers.map((m, i) => (
              <tr key={i} className="border-b">
                <td className="px-2 py-1">{m.preferred}</td>
                <td className="px-2 py-1">{m.first}</td>
                <td className="px-2 py-1">{m.last}</td>
                <td className="px-2 py-1">{m.id}</td>
                <td className="px-2 py-1">{m.dob}</td>
                <td className="px-2 py-1">{m.gender}</td>
                <td className="px-2 py-1">{m.pronouns}</td>
                <td className="px-2 py-1">{m.location}</td>
                <td className="px-2 py-1">{m.payroll}</td>
                <td className="px-2 py-1">{stressProfileMap[m.stress]}</td>
                <td className="px-2 py-1">{m.hired}</td>
                <td className="px-2 py-1">{m.archived}</td>
                <td className="px-2 py-1">{m.tenure}</td>
                <td className="px-2 py-1">{m.status}</td>
                <td className="px-2 py-1">{accessMap[m.access]}</td>
                <td className="px-2 py-1">{m.mobile}</td>
                <td className="px-2 py-1">{m.email}</td>
                <td className="px-2 py-1">{m.address}</td>
                <td className="px-2 py-1">{m.emergencyName}</td>
                <td className="px-2 py-1">{m.emergencyPhone}</td>
                <td className="px-2 py-1">{m.custom}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
